import { combineReducers } from 'redux';
import providerIncentiveCosts from './provider-incentive-cost-reducer';
import requestFilter from './request-filter-reducer';
import providers from './providers-reducer';
import newIncentive from './add-incentive-reducer';

export const reducer = combineReducers({ providerIncentiveCosts, requestFilter, providers, newIncentive });
